import React from "react";
import Box from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import Switch from "@mui/material/Switch";

function BooleanSetting({ setting, setParentState, styles = {} }) {
  const switchProps = {
    checked: !!setting.field_value,
    onChange: (e) => {
      setParentState(Number(e.target.checked));
    },
  };

  return (
    <Box sx={{ marginBottom: "2rem", ...styles }}>
      <FormControl component="fieldset">
        <FormGroup aria-label="position" row>
          <FormControlLabel
            value="start"
            control={<Switch {...switchProps} />}
            label={setting.en_field_label || ""}
            sx={{
              display: "flex",
              flexDirection: "row-reverse",
              paddingLeft: ".5rem",
            }}
          />
        </FormGroup>
      </FormControl>
    </Box>
  );
}

export default BooleanSetting;
